import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { DropOrChooseFile } from '../../Components/fileupload/DropOrChooseFile';
import ProfileBuilderWrapper from '../../Components/pages/profileBuilder.Wrapper/ProfileBuilderWrapper';

export function ProfileBuilderOne() {
  const pendingUpload = useSelector((state) => state.uploadData.pendingUpload);
  const pendingParse = useSelector((state) => state.uploadData.pendingParse);
  const [t] = useTranslation();

  return (
    <ProfileBuilderWrapper
      titleMain={t('profile.builder.start.title')}
      titleSecondary={t('profile.builder.start.upload')}
      text={t('profile.builder.start.description')}
      progress={17}
      loading={pendingParse || pendingUpload}
    >
      <div className="d-flex align-items-center justify-content-center">
        <DropOrChooseFile />
      </div>
    </ProfileBuilderWrapper>
  );
}
